module.exports = __webpack_public_path__ + "img/jpg-icon.bd14d68b.png";